import packageInfo from '../../package.json';

export const environment = {
  production: true,
  version: packageInfo.version,
  apiServerUrl: 'https://avcasdevsrv.aventit.ch',
  syncfusionKey: 'Ngo9BigBOggjHTQxAR8/V1JAaF5cX2pCd1p/TH5YfUNzdUVEY1ZUTXxaS1ZhSXxVdkJiX39cdXRVQWNeVUJ9W0A=',

  apiClientId: 'AvCasWeb',
  localStorageToken: 'token',
  localStorageRefreshToken: 'refreshToken',
  localStorageUserInfo: 'userInfo',
  supportedLanguages: 'en,de',
  alarmReloadInterval: 2000,
  idleTimeoutInSeconds: 60,
  localStorageActivityTimestamp: 'activityTimestamp',
  allowBrowserTranslation: true
};
